import axios from "axios";
import toast from "react-hot-toast";
import { config } from "../../Utils/helpers";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const viewCountryList = (countryData) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "GET_COUNTRY_LIST_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/country/list`,
        countryData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "GET_COUNTRY_LIST_SUCCESS", payload: data });
        dispatch({ type: "SET_FETCHED_TIME", payload: Date.now() });
      } else {
        dispatch({ type: "GET_COUNTRY_LIST_FAIL", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "GET_COUNTRY_LIST_FAIL",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const viewCountry = (countryData) => {
  return async (dispatch) => {
    // dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_COUNTRY_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.get(
        `${BASE_URL}/country/view/${countryData}`,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "GET_COUNTRY_SUCCESS", payload: data });
        dispatch({ type: "SET_FETCHED_TIME", payload: Date.now() });
      } else {
        dispatch({ type: "GET_COUNTRY_FAIL", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "GET_COUNTRY_FAIL",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const viewAllCity = () => {
  return async (dispatch) => {
    // dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET__ALL_CITY_LIST_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.get(
        `${BASE_URL}/city/alllist`,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "GET_ALL_CITY_LIST_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET__ALL_CITY_LIST_FAIL", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "GET__ALL_CITY_LIST_FAIL",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const viewCountryListPagination = () => {
  return async (dispatch) => {
    // dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_COUNTRY_LIST_REQUEST" });

      // const config = {
      //   headers: {
      //     "Content-Type": "application/json",
      //   },
      // };

      const { data } = await axios.get(`${BASE_URL}/country/alllist`, config);

      if (data.statusCode === 200) {
        dispatch({ type: "GET_COUNTRY_LIST_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_COUNTRY_LIST_FAIL", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "GET_COUNTRY_LIST_FAIL",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const viewStateList = (stateData) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "GET_STATE_LIST_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/state/list`,
        stateData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "GET_STATE_LIST_SUCCESS", payload: data });
        dispatch({ type: "SET_FETCHED_TIME", payload: Date.now() });
      } else {
        dispatch({ type: "GET_STATE_LIST_FAIL", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "GET_STATE_LIST_FAIL",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const viewState = (countryData) => {
  return async (dispatch) => {
    // dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_STATE_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.get(
        `${BASE_URL}/state/view/${countryData}`,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "GET_STATE_SUCCESS", payload: data });
        dispatch({ type: "SET_FETCHED_TIME", payload: Date.now() });
      } else {
        dispatch({ type: "GET_STATE_FAIL", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "GET_STATE_FAIL",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const viewStateListPagination = (stateData) => {
  return async (dispatch) => {
    // dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_STATE_LIST_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/state/alllist`,
        stateData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "GET_STATE_LIST_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_STATE_LIST_FAIL", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "GET_STATE_LIST_FAIL",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const viewCityListCab = (cityData) => {
  return async (dispatch) => {
    // dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_CITY_LIST_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/city/list-for-cab`,
        cityData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "GET_CITY_LIST_SUCCESS", payload: data });
        dispatch({ type: "SET_FETCH_TIME", payload: Date.now() });
      } else {
        dispatch({ type: "GET_CITY_LIST_FAIL", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "GET_CITY_LIST_FAIL",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const viewCityList = (cityData) => {
  return async (dispatch) => {
    // dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_CITY_LIST_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/city/list`,
        cityData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "GET_CITY_LIST_SUCCESS", payload: data });
        dispatch({ type: "SET_FETCH_TIME", payload: Date.now() });
      } else {
        dispatch({ type: "GET_CITY_LIST_FAIL", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "GET_CITY_LIST_FAIL",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const viewCityListPagination = (cityData) => {
  return async (dispatch) => {
    // dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_ALLS_CITY_LIST_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/city/alllist`,
        cityData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "GET_ALLS_CITY_LIST_SUCCESS", payload: { data: data.data } });
        dispatch({ type: "SET_FETCH_TIME", payload: Date.now() });
      } else {
        dispatch({ type: "GET_ALLS_CITY_LIST_FAIL", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "GET_ALLS_CITY_LIST_FAIL",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const addNewCountry = (countryData) => {
  // a single object which when called would get a state as an object
  return async (dispatch) => {
    // dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "ADD_COUNTRY_REQUEST" }); // initially an action to be sent to the reducer

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/country/add`,
        countryData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "ADD_COUNTRY_SUCCESS", payload: data });
        toast.success("Added Successfully!");
        return data;
      } else {
        dispatch({ type: "ADD_COUNTRY_FAIL", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "ADD_COUNTRY_FAIL",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const addNewCity = (cityData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "ADD_CITY_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/city/add`,
        cityData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "ADD_CITY_SUCCESS", payload: data });
        // toast.success("Added Successfully!");
        return data;
      } else {
        dispatch({ type: "ADD_CITY_FAIL", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "ADD_CITY_FAIL",
        payload: error?.response?.data?.message,
      });
    }
    dispatch({ type: "STOP_LOADING" });
  };
};

export const addNewState = (stateData) => {
  // added this code
  return async (dispatch) => {
    // dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "ADD_STATE_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/state/add`,
        stateData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "ADD_STATE_SUCCESS", payload: data });
        // toast.success("Added Successfully!");
        return data;
      } else {
        dispatch({ type: "ADD_STATE_FAIL", payload: data });
        return data;
      }
    } catch (error) {
      dispatch({
        type: "ADD_STATE_FAIL",
        payload: error?.response?.data?.message,
      });
    }
    dispatch({ type: "STOP_LOADING" });
  };
};

export const listCategory = (page, limit, category_id) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "LIST_CATEGORY_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/category/list`,
        { page, limit, category_id },
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "LIST_CATEGORY_SUCCESS", payload: data });
      } else {
        dispatch({ type: "LIST_CATEGORY_FAIL", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "LIST_CATEGORY_FAIL",
        payload: error?.response?.data?.message,
      });
    }
    dispatch({ type: "STOP_LOADING" });
  };
};

export const addCategory = (name, position, image, parent) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "ADD_CATEGORY_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/category/add`,
        { name, position, image, parent },
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "ADD_CATEGORY_SUCCESS", payload: data });
        toast.success("Added Successfully!");
      } else {
        dispatch({ type: "ADD_CATEGORY_FAIL", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "ADD_CATEGORY_FAIL",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const editCountry = (countryData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "EDIT_COUNTRY_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/country/update`,
        countryData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "EDIT_COUNTRY_SUCCESS", payload: data });
        toast.success("Edited Successfully!!");
        return data;
      } else {
        dispatch({ type: "EDIT_COUNTRY_FAILED", payload: data });
        return data;
      }
    } catch (error) {
      dispatch({
        type: "EDIT_COUNTRY_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message)
      return error?.response?.data?.message;
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const editCity = (cityData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "EDIT_CITY_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/city/update`,
        cityData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "EDIT_CITY_SUCCESS", payload: data });
        toast.success("Changed Successfully!!");
        return data;
      } else {
        dispatch({ type: "EDIT_CITY_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "EDIT_CITY_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

//Clearing Errors
export const clearErrors = () => async (dispatch) => {
  dispatch({ type: "CLEAR_ERRORS" });
};


export const viewCity = (cityId) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_CITY_REQUEST" });
      const config = {
        headers: { "Content-Type": "application/json" },
      };
      const { data } = await axios.get(`${BASE_URL}/city/view/${cityId}`, config);
      if (data.statusCode === 200) {
        dispatch({ type: "GET_CITY_SUCCESS", payload: data });
        dispatch({ type: "SET_FETCHED_TIME", payload: Date.now() });
        return data;  // <-- return data here
      } else {
        dispatch({ type: "GET_CITY_FAIL", payload: data });
        return null;
      }
    } catch (error) {
      dispatch({ type: "GET_CITY_FAIL", payload: error?.response?.data?.message });
      return null;
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const updateCity = (id, cityData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "EDIT_CITY_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.put(
        `${BASE_URL}/city/update/${id}`,
        cityData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "EDIT_CITY_SUCCESS", payload: data });
        toast.success("Changed Successfully!!");
        return data;
      } else {
        dispatch({ type: "EDIT_CITY_FAILED", payload: data });
        return data;
      }
    } catch (error) {
      dispatch({
        type: "EDIT_CITY_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
      return error?.response?.data?.message;
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};